import React from 'react'
import { connect } from 'react-redux'
import { fetchEntities } from 'actions/entities';
import EntitiesMenu from 'components/entities/EntitiesMenu';
import ConsultationsMenuItem from 'components/consultations/ConsultationsMenuItem'
import { getSortedConsultationsForListByKeyWindow } from 'selectors/consultations'



const mapStateToProps = (state, ownProps) => {
  let consultations = getSortedConsultationsForListByKeyWindow(ownProps.keyWindow)(state)

  return {
    entities: consultations,
    entityName: 'consultation',
    item: ConsultationsMenuItem,
    loading: state.meta.consultation.loading,
    error: state.meta.consultation.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultations'))
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu);
